import { render } from "./EmployeeCreate.vue?vue&type=template&id=d4771bea&scoped=true"
import script from "./EmployeeCreate.vue?vue&type=script&lang=js"
export * from "./EmployeeCreate.vue?vue&type=script&lang=js"

import "./EmployeeCreate.vue?vue&type=style&index=0&id=d4771bea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4771bea"]])

export default __exports__